import e from "react";
import { cloneAndRender as t } from "../../../../utils/template/index.js";
import r from "../../../../../node_modules/classnames/index.js";
var a = function a(_a) {
  var m = _a.className,
    l = _a.template,
    n = _a.item;
  if (l) return e.createElement(e.Fragment, null, t(l, _a));
  var i = n.title;
  return e.createElement("li", {
    className: r("sidebar-header", m)
  }, e.createElement("span", null, i));
};
export { a as SidebarHeading };